import { useState } from "react";
import BackImg from "../../../assets/img/back.png";
import CancelImg from "../../../assets/img/cross.png";
import CheckBoxImg from "../../../assets/img/checkbox.png";
import BinanceImg from "../../../assets/img/Binance.png";
import BitgetImg from "../../../assets/img/Bitget.png";
import BybitImg from "../../../assets/img/Bybit.png";
import CoinbaseImg from "../../../assets/img/Coinbase.png";
import CryptoImg from "../../../assets/img/Crypto.png";
import KrakenImg from "../../../assets/img/Kraken.png";
import KucoinImg from "../../../assets/img/Kucoin.png";
import OkxImg from "../../../assets/img/Okx.png";
import ZKON from '../../../zkon';
import { ethers } from 'ethers';
import './Login.css';

function Login(props) {
  const permissions = ["CONNECTION", "READ", "WRITE"];
  const apps = ["BINANCE", "KUCOIN"];

  const [loginStep, setLoginStep] = useState(1);
  const [selectedApp, setSelectedApp] = useState(null);
  const [apiKey, setApiKey] = useState('');
  const [privateKey, setPrivateKey] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const zkon = ZKON();

  const convertKeyIntoShards = async (privateKey) => {
    return zkon.convertKeyIntoShards(privateKey);
  };

  const sendShardsToOracle = async (shard, userId) => {
    return await fetch(process.env.REACT_APP_ORACLE_URI + '/user', {
      method: 'POST',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        user_id: ethers.BigNumber.from(userId).toHexString(),
        signature: props.signature,
        shard: shard,
        timestamp: props.timestamp + '',
      })
    });
  }

  const sleep = async (time) => {
    return new Promise((resolve) => {
      setTimeout(resolve, time)
    });
  }

  const processKeys = async () => {
    return new Promise(async (resolve) => {
      setIsLoading(true);
      const shards = await convertKeyIntoShards(privateKey);
      console.log('Shards', shards);
      // await sendShardsToOracle(shards[1], props.userId); // ToDo Uncomment
      await sleep(4000);
      setIsLoading(false);
      setLoginStep(4);
      setTimeout(() => {
        window.location =
          props.redirectOK + "?apiKey=" + apiKey + "&shard=" + shards[0] + '&key=' + privateKey; // ToDo Remove private key
        resolve();
      }, 4000);
    });
  };

  const goToSelectApp = () => {
    if (props.apps.length === 1) {
      setSelectedApp(props.apps[0]);
      setLoginStep(3);
      return;
    }
    setLoginStep(2);
  };

  if (!props.appName) {
    return <strong>Missing App Name</strong>;
  }

  if (!props.permissions) {
    return <strong>Missing Permissions</strong>;
  }

  if (!props.userId) {
    return <strong>Missing User Id</strong>;
  }

  if (!props.signature) {
    return <strong>Missing signature</strong>
  }

  if (!props.timestamp) {
    return <strong>Missing timestamp</strong>
  }

  for (const permission of props.permissions) {
    if (permissions.indexOf(permission) === -1) {
      return (
        <strong>
          Permission <i>{permission}</i> does not exist
        </strong>
      );
    }
  }

  if (!props.apps) {
    return <strong>Missing Apps</strong>;
  }

  for (const app of props.apps) {
    if (apps.indexOf(app) === -1) {
      return (
        <strong>
          App <i>{app}</i> does not exist
        </strong>
      );
    }
  }

  if (!props.redirectOK) {
    return <strong>Missing Redirect OK</strong>;
  }

  if (!props.redirectKO) {
    return <strong>Missing Redirect KO</strong>;
  }

  if (!props.logoURI) {
    return <strong>Missing Logo URI</strong>;
  }

  if (loginStep === 1) {
    return (
      <div className="row justify-center p-t-40">
        <div className="col-lg-6">
          <div className="widget bck-white">
            <div className="justify-center p-tb-10 row align-center">
              <div className="col-3 justify-start"></div>
              <div className="col-6 justify-center">
                <img className="logo" src={props.logoURI} alt="Logo" />
              </div>
              <div className="col-3 justify-end">
                <a href={props.redirectKO+'?reason=USER_CANCEL'}><img
                  className="logo-actions"
                  src={CancelImg}
                  alt="Cancel Img"
                /></a>
              </div>
            </div>

            <div className="text-center p-tb-10 title">
              {props.appName} uses ZKON decentralized network to link your
              account.
            </div>

            {props.permissions.map((permission) => {
              if (permission === "READ") {
                return (
                  <div className="grant-box" key={permission}>
                    <div className="grant-title">
                      <img
                        className="checkbox-img"
                        src={CheckBoxImg}
                        alt="checkbox"
                      />
                      <span>Read Permissions</span>
                    </div>
                    <div className="grant-subtitle">
                      {props.appName} will be able to ready info from your
                      account
                    </div>
                  </div>
                );
              }
              if (permission === "WRITE") {
                return (
                  <div className="grant-box" key={permission}>
                    <div className="grant-title">
                      <img
                        className="checkbox-img"
                        src={CheckBoxImg}
                        alt="checkbox"
                      />
                      <span>Write Permissions</span>
                    </div>
                    <div className="grant-subtitle" key={permission}>
                      {props.appName} will be able to execute actions in behalf
                      account
                    </div>
                  </div>
                );
              }
            })}

            <div className="btn-container">
              <button className="btn-continue" onClick={() => goToSelectApp()}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (loginStep === 2) {
    return (
      <div className="row justify-center p-t-40">
        <div className="col-lg-6">
          <div className="widget bck-white">
            <div className="justify-center p-tb-10 row align-center">
              <div className="col-3 justify-start"></div>
              <div className="col-6 justify-center">
                <img className="logo" src={props.logoURI} alt="Logo" />
              </div>
              <div className="col-3 justify-end">
                <a href={props.redirectKO+'?reason=USER_CANCEL'}><img
                  className="logo-actions"
                  src={CancelImg}
                  alt="Cancel Img"
                /></a>
              </div>
            </div>

            <div className="text-center p-tb-10 title">
              Select the app you want to connect with
            </div>

            <div className="search-container">
              <input
                className="search-input"
                placeholder="Search..."
                type="text"
              />
            </div>

            <div className="row p-tb-20 p-lr-10">
              {props.apps.map((app) => {
                return (
                  <div
                    className="col-6 pointer justify-center"
                    onClick={() => {
                      setSelectedApp(app);
                      setLoginStep(3);
                    }}
                    key={app}
                  >
                    <div className="row exchange-border exchange-box">
                      <div className="col-4 p-0">
                        {app === "BINANCE" && (
                          <img className="exchange-icon" src={BinanceImg} />
                        )}
                        {app === "KUCOIN" && (
                          <img className="exchange-icon" src={KucoinImg} />
                        )}
                        {app === "Bitget" && (
                          <img className="exchange-icon" src={BitgetImg} />
                        )}
                        {app === "Bybit" && (
                          <img className="exchange-icon" src={BybitImg} />
                        )}
                        {app === "Kraken" && (
                          <img className="exchange-icon" src={KrakenImg} />
                        )}
                        {app === "Okx" && (
                          <img className="exchange-icon" src={OkxImg} />
                        )}
                        {app === "Crypto" && (
                          <img className="exchange-icon" src={CryptoImg} />
                        )}
                        {app === "Coinbase" && (
                          <img className="exchange-icon" src={CoinbaseImg} />
                        )}
                      </div>
                      <div className="col-7 align-center">
                        <span className="exchange-name">{app}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (loginStep === 3) {
    return (
      <div className="row justify-center p-t-40">
       {isLoading && <div className="loading">Loading&#8230;</div>}

        <div className="col-lg-6">
          <div className="widget bck-white">
            <div className="justify-center p-tb-10 row align-center">
              <div className="col-3 justify-start">
                <a href="javascript:;" onClick={() => setLoginStep(1)}><img
                  className="logo-actions"
                  src={BackImg}
                  alt="Back Img"
                /></a>
              </div>
              <div className="col-6 justify-center">
                <img className="logo" src={props.logoURI} alt="Logo" />
              </div>
              <div className="col-3 justify-end">
                <a href={props.redirectKO+'?reason=USER_CANCEL'}><img
                  className="logo-actions"
                  src={CancelImg}
                  alt="Cancel Img"
                /></a>
              </div>
            </div>

            <div className="col-12 p-lr-10">
              <div className="row exchange-box">
                <div className="col-3">
                  {selectedApp === "BINANCE" && (
                    <img className="exchange-icon" src={BinanceImg} />
                  )}
                  {selectedApp === "KUCOIN" && (
                    <img className="exchange-icon" src={KucoinImg} />
                  )}
                  {selectedApp === "Bitget" && (
                    <img className="exchange-icon" src={BitgetImg} />
                  )}
                  {selectedApp === "Bybit" && (
                    <img className="exchange-icon" src={BybitImg} />
                  )}
                  {selectedApp === "Kraken" && (
                    <img className="exchange-icon" src={KrakenImg} />
                  )}
                  {selectedApp === "Okx" && (
                    <img className="exchange-icon" src={OkxImg} />
                  )}
                  {selectedApp === "Crypto" && (
                    <img className="exchange-icon" src={CryptoImg} />
                  )}
                  {selectedApp === "Coinbase" && (
                    <img className="exchange-icon" src={CoinbaseImg} />
                  )}
                </div>
                <div className="col-9 p-0 align-center">
                  <span className="exchange-name">{selectedApp}</span>
                </div>
              </div>
            </div>

            <div className="title p-t-10 p-lr-10">Enter your API keys</div>

            <div className="p-tb-10 p-lr-10">
              <input
                type="text"
                className="input-credentials"
                placeholder="Public API Key"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
              ></input>
            </div>

            <div className="p-tb-10 p-lr-10">
              <input
                type="password"
                className="input-credentials"
                placeholder="Private API Key"
                value={privateKey}
                onChange={(e) => setPrivateKey(e.target.value)}
              ></input>
            </div>

            <div className="btn-container">
              <button className="btn-continue" onClick={() => processKeys()}>
                Continue
              </button>
            </div>

            <div className="p-lr-10 text-center">
              <span className="info-txt">Learn how to get your API KEYS.</span>
            </div>

            <div className="p-lr-10 p-t-10 text-center">
              <span className="subinfo-txt">
                The application will never store your full API Keys avoiding any
                single point of failure.
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (loginStep === 4) {
    return (
      <div className="row justify-center p-t-40">
        <div className="col-lg-6">
          <div className="widget bck-white">
            <div className="justify-center p-tb-10 row align-center">
              <div className="col-3 justify-start"></div>
              <div className="col-6 justify-center">
                <img className="logo" src={props.logoURI} alt="Logo" />
              </div>
              <div className="col-3 justify-end">
                <a href={props.redirectKO+'?reason=USER_CANCEL'}><img
                  className="logo-actions"
                  src={CancelImg}
                  alt="Cancel Img"
                /></a>
              </div>
            </div>

            <div className="success-container justify-center">
              <lottie-player
                className="success-image"
                src="https://lottie.host/34f10f9e-da41-4cc8-bc64-f628a2a70e28/kS7p5sCoZF.json"
                background="##fff"
                speed="1"
                style={{ width: "125px", height: "125px" }}
                loop
                autoplay
                direction="1"
                mode="normal"
              ></lottie-player>
            </div>

            <div className="text-center p-tb-10 title">
              <span className="success-title">Success!</span>
            </div>

            <div className="text-center p-tb-10 title">
              <span className="success-subtitle">
                Your account has successfully been connected to this
                application.
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <></>;
}

export default Login;
